(function () {
  'use strict';

  /* @ngdoc object
   * @name documentManager
   * @description
   *
   */
  angular
    .module('documentManager', [
      'ui.router'
    ]);
}());
